export declare type ProviderType = 'defaultProvider';

export const defaultProviderName: ProviderType = 'defaultProvider';
